import { Enums } from '@bode-canada/core';

export default class UserListing {
  constructor(userListing, phoneNumber, isPhoneVisible) {
    Object.assign(this, userListing);
    this.phone = phoneNumber || userListing.phone;
    this.isPhoneNumberVisible = isPhoneVisible;
    this.accountName = userListing?.accountName
      || (this.builderAccount || this.realtorAccount)?.name;
  }

  get isBuilder() {
    return !!this.builderAccount;
  }

  get builderAccount() {
    return this.#getAccountByType(Enums.BusinessAccountTypeEnum.BUILDER);
  }

  get realtorAccount() {
    return this.#getAccountByType(Enums.BusinessAccountTypeEnum.REALTOR);
  }

  #getAccountByType(accountType) {
    return (this.userBusinessAccounts || [])
      .find(({ businessAccount }) => businessAccount.type === accountType)
      ?.businessAccount;
  }
}
